@for (action of actions; track action) {
    <button [adaptBlockingClick]="addProcessStep"
            [adaptBlockingClickParam]="action.type">
        <i [ngClass]="action.iconClass"></i>
        <span class="add-text">{{ action.text }}</span>
    </button>
}
